import { all, takeLatest } from 'redux-saga/effects';
import { put } from 'redux-saga/effects';

import * as fusionSagas from './fusion';
import * as legadoSagas from './legado';
import {
  types as fusionTypes,
  actions as fusionActions,
} from '../reducers/fusion';
import * as filterSagas from './filters';
import {
  types as filterTypes,
  actions as filterActions, 
} from '../reducers/filters';
import {
  types as selectTypes,
  actions as selectActionsn,
} from '../reducers/select';
import { types as legadoTypes } from '../reducers/legado';

export function* handleSagaError(reducerFailureAction) {
  if (reducerFailureAction) {
    yield put(reducerFailureAction);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(fusionTypes.GET_ALL_PRODUCTS_BEGINS, fusionSagas.getAllProducts),
    takeLatest(
      fusionTypes.GET_SUBPRODUCTS_FROM_PRODUCTS_BEGINS,
      fusionSagas.getSubproductsFromProducts
    ),
    takeLatest(filterTypes.GET_FILTERS, filterSagas.getFilters),
    takeLatest(filterTypes.FILTER, fusionSagas.filter),
    takeLatest(selectTypes.SELECT, fusionSagas.selectProductSaga),
    takeLatest(
      fusionTypes.GET_HIRED_PRODUCTS_BEGINS,
      fusionSagas.getMyProducts
    ),
    takeLatest(
      fusionTypes.GET_CLIENT_DEMANDS_BY_PRODUCTID_BEGINS,
      fusionSagas.getClientDemandsByProductId
    ),
    takeLatest(
      fusionTypes.GET_PREVENTION_PRODUCT_BEGINS,
      fusionSagas.getPreventProduct
    ),
    takeLatest(
      fusionTypes.GET_MY_HIRED_PRODUCT_R2R_PRICE_BEGINS,
      fusionSagas.saveProductIncludedOrAditional
    ),
    takeLatest(
      fusionTypes.GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_BEGINS,
      fusionSagas.saveProductIncludedOrAditional
    ),
    takeLatest(legadoTypes.GET_PARQUE_CODE, legadoSagas.iframeCCLISubscription),
  ]);
}
